const state = () => ({
    conditions: [],
})

export default state